/**
 * Site Configuration
 * Edit this file to customize your blog's appearance and settings
 */

export const siteConfig = {
  // Site name displayed in header and title
  name: 'ByteJourney',

  // Site description for SEO
  description: 'ByteJourney shares deep insights, practical strategies, and forward-thinking ideas on AI, SEO, and emerging technologies to help you navigate the fast-changing digital landscape.',

  // Footer text
  footer: {
    // Use {year} as placeholder for dynamic year
    copyright: '© {year} Powered by ByteJourney',
    links: [
      {
        label: 'Privacy',
        url: '/privacy',
      },
      {
        label: 'Terms',
        url: '/terms',
      },
      {
        label: 'GitHub',
        url: 'https://github.com/alps99/',
      },
    ],
  },

  // Logo configuration
  logo: {
    // Logo type: 'icon' | 'image' | 'text'
    type: 'image' as 'icon' | 'image' | 'text',

    // If type is 'image', provide the URL
    imageUrl: '/clear-image.png',

    // If type is 'text', this will be displayed
    text: 'B',

    // Icon SVG path (used when type is 'icon')
    // This is a compass/pen icon representing "journey" and "writing"
    iconPath: `
      <path d="M12 19l7-7 3 3-7 7-3-3z" />
      <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
      <path d="M2 2l7.586 7.586" />
      <circle cx="11" cy="11" r="2" />
    `,

    // Gradient colors for icon background
    gradientFrom: 'from-primary-500',
    gradientTo: 'to-indigo-600',

    // Text gradient colors
    textGradientFrom: 'from-primary-600',
    textGradientTo: 'to-indigo-600',
  },

  // Social links (for future use)
  social: {
    github: 'https://github.com/alps99/',
    twitter: '',
    email: '',
  },

  // Theme colors (references Tailwind classes)
  theme: {
    primaryColor: 'primary-600',
    accentColor: 'indigo-600',
  },

  // Articles per page
  articlesPerPage: 10,

  // Enable/disable features
  features: {
    comments: true,
    tags: true,
    search: true,
    darkMode: true, // Theme toggle enabled
  },
};

export type SiteConfig = typeof siteConfig;
